// extracted by mini-css-extract-plugin
export default {"info":"NotFound_info__M10Db","head":"NotFound_head__UTTnb","title":"NotFound_title__dkgbu","text":"NotFound_text__8zbgC","link":"NotFound_link__SvXbU"};